import { ApiEndpoints, APIMethods } from "@typeDefinitions";
import { fetchData } from "@utils/api";
import * as yup from "yup";

export const fetchEducationalMaterialFile = async (
  id: number,
): Promise<EducationalMaterialFileResponse> => {
  const response = await fetchData(
    `${ApiEndpoints.EducationalMaterialFiles}/${id}`,
    APIMethods.GET,
  );

  return await educationalMaterialFileSchema.validate(response);
};

export interface TranslationType {
  lang: string;
  name: string | null;
  description: string | null;
}

export const translationSchema = yup.object({
  lang: yup.string().required(),
  name: yup.string().nullable().defined(),
  description: yup.string().nullable().defined(),
});

export interface ImageType {
  id: number;
  url: string;
}

export const imageSchema = yup.object({
  id: yup.number().required(),
  url: yup.string().required(),
});

export const categorySchema = yup.object({
  id: yup.number().nullable().defined(),
});

export interface CategoryType {
  id: number | null;
}

export interface EducationalMaterialData {
  id: number;
  name: string | null;
  description: string | null;
  translations: TranslationType[];
  image: ImageType | null;
  pdf: ImageType | null;
  category: CategoryType | null;
  reviewed?: boolean | null;
}

export const educationalMaterialDataSchema = yup.object({
  id: yup.number().required(),
  name: yup.string().nullable().defined(),
  description: yup.string().nullable().defined(),
  translations: yup.array().of(translationSchema).required(),
  image: imageSchema.nullable(),
  category: categorySchema.nullable(),
  pdf: imageSchema.nullable(),
  reviewed: yup.boolean().nullable(),
});

export interface EducationalMaterialFileResponse {
  data: EducationalMaterialData;
}

export const educationalMaterialFileSchema = yup.object({
  data: educationalMaterialDataSchema.required(),
});
